module.exports = __webpack_public_path__ + "static/media/INZ1023.502e189b.pdf";